import {Collection} from '@ab/components';
import queryParams from '../queries/percent.cll.q';
import Model from '../models/percent.m';

class Percent extends Collection {
    static model = Model;

    static queryParams = queryParams;
}

export default Percent;
